import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { Button as AntButton } from 'antd';
import { darken, getLuminance, lighten, setLightness } from 'polished';

var isBright = function isBright(color) {
  return getLuminance(color) > 0.5;
};

function generateTextColor(colorPalletes) {
  var colorScheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  var pallete = colorPalletes[colorScheme];

  if (type !== 'primary') {
    return pallete;
  }

  return isBright(pallete) ? colorPalletes.dark : colorPalletes.light;
}

function generateTextColorOnHover(colorPalletes) {
  var colorScheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  var unhoveredColor = generateTextColor(colorPalletes, colorScheme, type);

  if (type === 'link') {
    return isBright(colorPalletes[colorScheme]) ? darken(0.12, unhoveredColor) // originally chroma.darken(0.75)
    : lighten(0.165, unhoveredColor); // originally chroma.brighten(0.75)
  }

  return unhoveredColor;
}

function generateBackgroundColorOnHover(colorPalletes) {
  var colorScheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  var pallete = colorPalletes[colorScheme];

  switch (type) {
    case 'primary':
      // originally chroma.brighten(0.5)
      return lighten(0.125, pallete);

    case 'default':
    case 'dashed':
      // originally alpha(0.1)
      return setLightness(0.95, pallete);

    default:
      return 'inherit';
  }
}

var Button = styled(AntButton).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['colorScheme', 'minWidth'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["&& {\n  padding-left: ", ";\n  padding-right: ", "; \n  padding: ", ";\n  height: ", ";\n  font-weight: ", ";\n  min-width: ", ";\n  border-radius: ", ";\n  text-decoration: ", ";\n  \n  &:not(:disabled) {\n    ", "\n    color: ", ";\n    border-color: ", ";\n\n    &:hover, &:focus {\n      background-color: ", ";\n      color: ", ";\n      text-decoration: ", ";\n      border-color: ", ";\n    }\n  } \n  \n  span {\n    font-size: ", ";\n  }\n}"])), function (props) {
  return props.type === 'link' && '0';
}, function (props) {
  return props.type === 'link' && '0';
}, function (props) {
  return props.padding;
}, function (props) {
  return props.height;
}, function (props) {
  return !['link', 'text'].includes(props.type) && 'bold';
}, function (props) {
  return props.minWidth;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.type === 'link' && 'underline';
}, function (props) {
  return props.type === 'primary' && "\n      background-color: ".concat(props.theme.colors[props.colorScheme || 'primary'], ";\n    ");
}, function (props) {
  return props.color || generateTextColor(props.theme.colors, props.colorScheme, props.type);
}, function (props) {
  return props.color || (['primary', 'link', 'text'].includes(props.type) ? 'transparent' : generateTextColor(props.theme.colors, props.colorScheme, props.type));
}, function (props) {
  return generateBackgroundColorOnHover(props.theme.colors, props.colorScheme, props.type);
}, function (props) {
  return props.color || generateTextColorOnHover(props.theme.colors, props.colorScheme, props.type);
}, function (props) {
  return props.type === 'link' && 'underline';
}, function (props) {
  return props.color || (['primary', 'link', 'text'].includes(props.type) ? 'transparent' : generateTextColor(props.theme.colors, props.colorScheme, props.type));
}, function (props) {
  return props.textSize;
});
export default Button;